import { useState } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName} from './Univ.js'
function Register() {
  const navigate = useNavigate();
  const [errorMsg, seterrorMsg] = useState('');
  const [succesMsg, setsuccessMsg] = useState('');
  const [registerFormData, setRegisterFormData] = useState({
        "location":'',
        "role":'',
        "mobile":'',
        "username":'',
        "password":'',
    });

  const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        })
  };

  const submitHandler = (event) => {
        const formData = new FormData();
        const location = document.getElementById("location").value;
        formData.append('location',location);
        formData.append('username',registerFormData.username);
        formData.append('password',registerFormData.password);

        axios.post(baseUrl+'user-register/', formData)
          .then((response) => {
            if(response.status==200 || response.status==201){
            Swal.fire({
                  title: 'Registeration Done.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
            }
             window.location.reload();
          })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add. Please try again later.',
                'error'
              );
          });
    };
    const buttonEnable = (registerFormData.username!='') && (registerFormData.password!='')
  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>User Registration</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>
                        <div className="mb-3">
                              <label htmlFor="Location" className="form-label">Location</label>
                              <select value={registerFormData.location} onChange={inputHandler} className="form-control"
                                name="location" id="location">
                                <option value="1">Branch 1</option>
                                <option value="2">Branch 2</option>
                              </select>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="Username" className="form-label">Username</label>
                            <input type="text" placeholder="Username" className="form-control"
                               name="username" value={registerFormData.username} onChange={inputHandler} />
                        </div>
                        <div className="mb-3">
                              <label htmlFor="Password" className="form-label">Password</label>
                              <input type="password" className="form-control" placeholder="Password"
                               name="password" value={registerFormData.password} onChange={inputHandler} />
                        </div>
                        <button type="button" disabled={!buttonEnable} onClick={submitHandler}
                        className="btn btn-primary">Register</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default Register;
